<template>
  <div>
    <div class="exam-detail container">
      <div class="header">
        <el-breadcrumb class="breadcrumb"
                       separator="/">
          <el-breadcrumb-item>内容管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/exam/list' }">在线题库</el-breadcrumb-item>
          <el-breadcrumb-item>题库详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
          <div class="left">
            <div class="status">
              <span class="label">发布状态：</span>
              <el-switch v-model="exam.status"
                         @change="updateExamInfo"></el-switch>
            </div>
          </div>
          <div class="right">
            <el-button type="primary"
                       @click="handleToPreview">预览</el-button>
          </div>
        </div>
      </div>
      <ExamInfo class="info-card"
                :content="exam"
                @submit="fetchExamInfo" />
      <div class="main">
        <div class="tabs">
          <div :class="{'tab-item': true, 'active': tabKey == 'chapter'}"
               @click="handleTabChange('chapter')">章节列表</div>
        </div>
        <Chapter :exam="exam"
                 v-if="tabKey=='chapter'"
                 @detailPaper="getPaperDetail"></Chapter>
      </div>

    </div>
    <TestPaper :paperList="paperList"
               :paperName="paperName"></TestPaper>
  </div>
</template>

<script>
import ExamInfo from '@/components/card/ExamInfo'
import TestPaper from '@/components/testPaper/testPaper.vue'
import Chapter from './examChapter'
import {
  examOne,
  examUpdateStatus,
  examPaperItemList,
  examPaperOne,
} from '@/api/exam'

export default {
  components: {
    ExamInfo,
    Chapter,
    TestPaper,
  },
  data() {
    return {
      tabKey: 'chapter',
      expands: [],
      insertId: '',
      exam: {},
      results: [],
      paperList: [],
      paperName: '',
    }
  },
  created() {
    this.fetchExamInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    getPaperDetail(data) {
      console.log('data', data)
      examPaperOne({ id: data.paper_id }).then((res) => {
        if (res) {
          this.paperName = res.name
          console.log('res', res)
          // this.paper = res
          // this.fetchExamPaperItemList()
        }
      })
      examPaperItemList({ paper_id: data.paper_id }).then((res) => {
        this.paperList = res.list || []
      })
    },
    // 题库基本信息
    fetchExamInfo() {
      examOne({ id: this.$route.params.examId }).then((res) => {
        this.exam = res
        this.exam.status = this.exam.status == 1 ? true : false
      })
    },
    // 更新题库在线状态
    updateExamInfo() {
      examUpdateStatus({
        id: this.$route.params.examId,
        status: this.exam.status ? 1 : 0,
      })
        .then((res) => {
          this.$message.success(`发布状态更新成功`)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    handleTabChange(key) {
      this.tabKey = key
    },
    // 页面滚动到顶部
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    // 预览
    handleToPreview() {
      // if (this.exam && this.exam.subjects && this.exam.subjects[0]) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/subject/${this.exam.subjects[0].id}/exercise/${this.exam.id}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/subject/${this.exam.subjects[0].id}/exercise/${this.exam.id}`)
      //   }
      // }
    },
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
    },
  },
}
</script>

<style scoped lang="less">
.exam-detail {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .info-card {
    margin-top: 10px;
  }
  .main {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 20px;
    overflow: hidden;
    margin-top: 10px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .tabs {
      position: absolute;
      left: 20px;
      top: 20px;
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tab-item {
        font-size: 14px;
        cursor: pointer;

        &.active {
          font-size: 16px;
          font-weight: bold;
          cursor: default;
        }
      }
    }
  }
  .table-wrap {
    /deep/ .title-cell {
      width: 50px;

      .cell {
        display: flex;
        align-items: center;
      }
      .input {
        width: 250px;
        height: 32px;
        line-height: 32px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #606266;
        padding: 0 15px;
        outline: 0;

        &:focus {
          background: #fff;
          border-color: #409eff !important;
        }
      }

      &:hover .input {
        background: #fff;
        border-color: #dcdfe6;
      }
    }
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      &:hover .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .menu-wrap {
        display: none;
      }
    }
  }
}
</style>
